module.exports = __webpack_public_path__ + "img/Group 240.caaf34f3.svg";